import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/medical-history/pregnanciesAndChildren";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	pregnanciesAndChildren: {
		id: "form.pregnancies_and_children",
		defaultMessage: "Terhességek"
	},
	numberOfPregnancies: {
		id: "form.pregnancies_and_children.pregnancies",
		defaultMessage: "Terhességek száma"
	},
	numberOfChildren: {
		id: "form.pregnancies_and_children.children",
		defaultMessage: "Gyerekek száma"
	}
});

const fields: { [key: string]: FieldData } = {
	numberOfPregnancies: {
		type: "field",
		path: ["numberOfPregnancies"],
		label: messages.numberOfPregnancies,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	numberOfChildren: {
		type: "field",
		path: ["numberOfChildren"],
		label: messages.numberOfChildren,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.numberOfPregnancies },
				{ width: 6, field: fields.numberOfChildren }
			]
		}
	]
};

export const node: LeafNode = {
	id: "pregnanciesAndChildren",
	value: {
		title: messages.pregnanciesAndChildren,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
